import { currencies } from '../constants';

export const pushComponentAnchorLinkInteraction = (
  items: Record<string, any>[],
) => {
  dataLayer?.push({
    event: 'component_anchor_link_interaction',
    location: 'digital_sampling',
    page_type: 'quickview',
    ecommerce: {
      currency: currencies[ENVIRONMENT_REGION],
      value: 0,
      items,
    },
  });
};
